const styles = {
  primaryColor: '#082040',
  secondaryColor: '#ebdb91',
  headerAnimation: {
    delay: 500,
    from: {
      scale: 0.98,
      opacity: 0,
      yPercent: -100,
    },
    to: {
      scale: 1,
      opacity: 1,
      yPercent: 0,
      stagger: 0.05,
      duration: 0.5,
      ease: 'power3.inOut',
    },
  },
  preloaderAnimation: {
    from: {
      opacity: 0.8,
      scale: 0.8,
      yPercent: -20,
    },
    to: {
      opacity: 1,
      scale: 1,
      ease: 'power4.inOut',
      duration: 0.5,
      yPercent: 0,
    },
  },
  preloaderPulseAnimation: {
    from: {
      opacity: 0.3,
      duration: 1,
    },
    to: {
      opacity: 1,
      duration: 1,
    },
  },
  preloaderExitAnimation: {
    opacity: 0,
    duration: 0.6,
    ease: 'power3.inOut',
  },
}

export default styles
